import { config } from "@/lib/shared/config";
import { CliError } from "@/lib/cli/cli-error";
import { CLI_ERROR_CODES } from "@/lib/shared/errors-constants";
import type { RequestOptions } from "@/lib/request/request-options";
export function authHeaders(as: RequestOptions["as"]): Record<string, string> {
  if (as) {
    return { authorization: `Bearer ${as.token}` };
  }

  const apiKey = process.env.HEPHA_API_KEY;
  if (apiKey) {
    // An agent's key wins over any stored human session, so a CI run is never
    // silently attributed to whoever last ran `hepha login` on the machine.
    return { "x-api-key": apiKey };
  }

  const token = process.env.HEPHA_TOKEN ?? config.load().token;
  if (token) {
    return { authorization: `Bearer ${token}` };
  }

  throw new CliError(
    "Not signed in. Run `hepha login`, or set HEPHA_API_KEY to act as an agent.",
    1,
    { code: CLI_ERROR_CODES.NOT_AUTHENTICATED },
  );
}
